import { Provider } from '@angular/core';
import { QueryClient, provideTanStackQuery } from '@tanstack/angular-query-experimental';

export function provideQueryClient(): Provider[] {
  return provideTanStackQuery(new QueryClient());
}
